// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';

// Optional: Define a custom theme
const theme = extendTheme({
  colors: {
    brand: {
      100: "#EBF8FF",
      200: "#BEE3F8",
      300: "#90CDF4",
      400: "#63B3ED",
      500: "#4299E1", // The default color shade
      600: "#3182CE", // The hover color shade
      700: "#2B6CB0",
      800: "#2C5282",
      900: "#1A365D",
    },
  },
  components: {
    Button: {
      // This explicitly tells Chakra how to style the solid variant of the brand button
      variants: {
        solid: (props) => {
          if (props.colorScheme === 'brand') {
            return {
              bg: 'brand.500', // Default background
              color: 'white',   // Default text color
              _hover: {
                bg: 'brand.600', // Hover background
              },
              _active: {
                bg: 'brand.700', // Clicked background
              }
            };
          }
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);